import { Component, Prop } from "vue-property-decorator";
import { VueBase } from "../../../components/Controls/VueBase";

export interface IProgress {
	value: number,
	color: string
}

@Component
export default class CircularProgressComponent extends VueBase {
	@Prop({ type: Array, required: true })
	public readonly progressList!: IProgress[]

	@Prop({ type: String, required: true })
	public readonly backgroundColor!: string;

	// Calcul du style dynamique pour le background
	public get circularStyle(): { background: string } {
		// Définition du radial-gradient pour le fond du cercle
		const radial = `radial-gradient(closest-side, ${this.backgroundColor} 80%, transparent 80% 100%)`;

		if (this.progressList && this.progressList.length > 0) {
			// Calcul du total pour déterminer la proportion de chaque segment
			const total = this.progressList.reduce((sum, p) => sum + p.value, 0);

			if (total === 0) {
				// Cas où toutes les valeurs sont à 0 : cercle neutre
				return {
					background: `${radial}, conic-gradient(rgb(225, 231, 242) 0% 100%)`
				};
			}

			let current = 0;
			const stops: string[] = [];

			// Construction des stops pour le conic-gradient
			this.progressList.forEach((p) => {
				const start = (current / total) * 100;
				current += p.value;
				const end = (current / total) * 100;
				stops.push(`${p.color} ${start}% ${end}%`);
			});

			// Définition du conic-gradient pour les segments colorés
			const conic = `conic-gradient(${stops.join(", ")})`;

			return {
				background: `${radial}, ${conic}`
			};
		}

		return {
			background: `${radial}, conic-gradient(rgb(225, 231, 242) 0% 100%)`
		};
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/circularProgress/circularProgress.ts